// const baseUrl = `http://localhost:5000`; // FE + BE Development
// const baseUrl = 'https://monitor.srhr.org'; // FE Development
const baseUrl = `${window.location.protocol}//${window.location.host}`; // Production

export const indicatorEndpoint = `${baseUrl}/indicator`;
export const pdfEndpoint = `${baseUrl}/pdf`;
